import { render, staticRenderFns } from "./admin-adminLogs.vue?vue&type=template&id=746ae4a2&"
import script from "./admin-adminLogs.vue?vue&type=script&lang=js&"
export * from "./admin-adminLogs.vue?vue&type=script&lang=js&"
import style0 from "./admin-adminLogs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports